type State = "current" | "milestone" | "past";

export function RevDot({ n, state }: { n: number; state: State }) {
  const cls = "dot " + (state === "current" ? "current" : state === "milestone" ? "green" : "");
  return <span className={cls}>{n}</span>;
}
